import React from 'react';

import {
    BrowserRouter, Route, Switch,
} from 'react-router-dom';

import AdminPermissions from './AdminPermissions';
import AdminRoles from './AdminRoles';
import AdminUserAddScreen from './AdminUserAdd';
import AuthCheck from './AuthCheck';
import AuthorEditScreen from './AuthorEditScreen';
import AuthorsScreen from './AuthorsScreen';
import AuthScreen from './AuthScreen';
import BetakeyEditScreen from './BetakeyEditScreen';
import BetakeysScreen from './BetakeysScreen';
import BetakeyUsersScreen from './BetakeyUsersScreen';
import Canonical from './Canonical';
import CanonicalList from './CanonicalList';
import ChannelsEditScreen from './ChannelsEditScreen';
import ChannelsScreen from './ChannelsScreen';
import CommercialEditScreen from './CommercialEditScreen';
import GameEditScreen from './GameEditScreen';
import GameScreen from './GameScreen';
import HotboxScreen from './HotboxScreen';
import Main from './Main';
import PocketsManager from './Pockets';
import PocketsQuasisection from './PocketsQuasisection';
import PollEditScreen from './PollEditScreen';
import PollScreen from './PollScreen';
import QuizEditScreen from './QuizEditScreen';
import QuizScreen from './QuizScreen';
import QuizTriviaEditScreen from './QuizTriviaEditScreen';
import QuizTriviaScreen from './QuizTriviaScreen';
import RawHtmlEditScreen from './RawHtmlEditScreen';
import RawHtmlScreen from './RawHtmlScreen';
import ReportScreen from './ReportScreen';
import StoryEditScreenV2 from './StoryEditScreenV2';
import StoryListV2 from './StoryListV2';
import TableHtmlEditScreen from './TableHtmlEditScreen';
import TableHtmlScreen from './TableHtmlScreen';
import TagEditScreen from './TagEditScreen';
import TagScreen from './TagScreen';
import Page from '../components/Page';
import { PROJECT_PREFIX } from '../const';
import FileStorageUtility from '../pages/FileStorageUtility/FileStorageUtility';
import StoryListV3 from '../pages/StoryList';
import Video from '../pages/Video/Video';
import VideoList from '../pages/VideoList';

export default function Router() {
    return (
        <BrowserRouter>
            <Page>
                <Switch>
                    <Route path={`${PROJECT_PREFIX}/`} component={Main} exact />
                    <Route path={`${PROJECT_PREFIX}/auth/`} component={AuthScreen} />
                    <Route path={`${PROJECT_PREFIX}/authors/all`} component={AuthorsScreen} />
                    <Route path={`${PROJECT_PREFIX}/authors/new`} component={AuthorEditScreen} />
                    <Route path={`${PROJECT_PREFIX}/authors/:authorEmail/edit`} component={AuthorEditScreen} />

                    <Route path={`${PROJECT_PREFIX}/betakeys/all`} component={BetakeysScreen} />
                    <Route path={`${PROJECT_PREFIX}/betakeys/new`} component={BetakeyEditScreen} />
                    <Route path={`${PROJECT_PREFIX}/betakeys/:keyId/edit`} component={BetakeyEditScreen} />
                    <Route path={`${PROJECT_PREFIX}/betakeys/:keyId/users`} component={BetakeyUsersScreen} />

                    <Route path={`${PROJECT_PREFIX}/channels/all`} component={ChannelsScreen} />
                    <Route path={`${PROJECT_PREFIX}/channels/new`} component={ChannelsEditScreen} />
                    <Route path={`${PROJECT_PREFIX}/channels/:id/edit`} component={ChannelsEditScreen} />

                    <Route path={`${PROJECT_PREFIX}/tags/all`} component={TagScreen} />
                    <Route path={`${PROJECT_PREFIX}/tags/new`} component={TagEditScreen} />
                    <Route path={`${PROJECT_PREFIX}/tags/:tagId/edit`} component={TagEditScreen} />

                    <Route path={`${PROJECT_PREFIX}/reports`} component={ReportScreen} />

                    <Route path={`${PROJECT_PREFIX}/hotbox/`} component={HotboxScreen} />
                    <Route path={`${PROJECT_PREFIX}/utility/file-storage/`} component={FileStorageUtility} />

                    <Route path={`${PROJECT_PREFIX}/games/all`} component={GameScreen} />
                    <Route path={`${PROJECT_PREFIX}/games/new`} component={GameEditScreen} />
                    <Route path={`${PROJECT_PREFIX}/games/:topicId/edit`} component={GameEditScreen} />

                    <Route path={`${PROJECT_PREFIX}/pocket/:pocket/:param?`} component={PocketsManager} />
                    <Route
                        path={`${PROJECT_PREFIX}/pockets/industry/:project`}
                        render={(props) => (
                            <PocketsQuasisection {...props} section="industry" project="games.mail.ru" />
                        )}
                    />

                    <Route path={`${PROJECT_PREFIX}/poll/all`} component={PollScreen} />
                    <Route path={`${PROJECT_PREFIX}/poll/:id/edit`} component={PollEditScreen} />
                    <Route path={`${PROJECT_PREFIX}/poll/new`} component={PollEditScreen} />

                    <Route path={`${PROJECT_PREFIX}/quiz/all`} component={QuizScreen} />
                    <Route path={`${PROJECT_PREFIX}/quiz/new`} component={QuizEditScreen} />
                    <Route path={`${PROJECT_PREFIX}/quiz/:id/edit`} component={QuizEditScreen} />

                    <Route path={`${PROJECT_PREFIX}/quiz_trivia/all`} component={QuizTriviaScreen} />
                    <Route path={`${PROJECT_PREFIX}/quiz_trivia/new`} component={QuizTriviaEditScreen} />
                    <Route path={`${PROJECT_PREFIX}/quiz_trivia/:id/edit`} component={QuizTriviaEditScreen} />

                    <Route path={`${PROJECT_PREFIX}/rawhtml/all`} component={RawHtmlScreen} />
                    <Route path={`${PROJECT_PREFIX}/rawhtml/new`} component={RawHtmlEditScreen} />
                    <Route path={`${PROJECT_PREFIX}/rawhtml/:id/edit`} component={RawHtmlEditScreen} />

                    <Route path={`${PROJECT_PREFIX}/table/all`} component={TableHtmlScreen} />
                    <Route path={`${PROJECT_PREFIX}/table/new`} component={TableHtmlEditScreen} />
                    <Route path={`${PROJECT_PREFIX}/table/:id/edit`} component={TableHtmlEditScreen} />

                    <Route path={`${PROJECT_PREFIX}/canonical/all`} component={CanonicalList} />
                    <Route path={`${PROJECT_PREFIX}/canonical/new`} component={Canonical} />
                    <Route path={`${PROJECT_PREFIX}/canonical/:id/edit`} component={Canonical} />

                    <Route exact path={`${PROJECT_PREFIX}/admin/users`} component={AdminPermissions} />
                    <Route path={`${PROJECT_PREFIX}/admin/users/add`} component={AdminUserAddScreen} exact />
                    <Route exact path={`${PROJECT_PREFIX}/admin/users/roles/`} component={AdminRoles} />

                    {/* Используется в gof https://gof.vkplay.ru/about/ */}
                    <Route
                        path={`${PROJECT_PREFIX}/:project/story/static/all`}
                        render={(props) => {
                            const { match: { params: { project } } } = props;

                            return <StoryListV2 {...props} type="static" project={project} />;
                        }}
                    />

                    <Route path={`${PROJECT_PREFIX}/:project/story/commercial/new`} component={CommercialEditScreen} />
                    <Route path={`${PROJECT_PREFIX}/:project/story/commercial/:storyId/edit`} component={CommercialEditScreen} />

                    <Route
                        path={`${PROJECT_PREFIX}/:project/story/compilation/all`}
                        render={(props) => {
                            const { match: { params: { project } } } = props;

                            return <StoryListV2 {...props} type="compilation" project={project} />;
                        }}
                    />
                    <Route path={`${PROJECT_PREFIX}/video/`} component={VideoList} exact />
                    <Route path={`${PROJECT_PREFIX}/video/:id/`} component={Video} exact />
                    <Route
                        path={`${PROJECT_PREFIX}/:project/story/compilation/new`}
                        render={(props) => {
                            const { match: { params: { project } } } = props;

                            return (
                                <StoryEditScreenV2
                                    {...props}
                                    type="compilation"
                                    project={project}
                                />
                            );
                        }}
                    />
                    <Route
                        path={`${PROJECT_PREFIX}/:project/story/compilation/:storyId/edit`}
                        render={(props) => {
                            const { match: { params: { project, storyId } } } = props;

                            return (
                                <StoryEditScreenV2
                                    {...props}
                                    storyId={storyId}
                                    type="compilation"
                                    project={project}
                                    isArticle
                                />
                            );
                        }}
                    />

                    <Route
                        path={`${PROJECT_PREFIX}/:project/story/:type/:cybersport?/all`}
                        render={(props) => {
                            const { location, match: { params: { type, project } } } = props;

                            const search = new URLSearchParams(location.search);
                            const tag = search.get('tag') || '';

                            return (
                                <StoryListV3
                                    {...props}
                                    project={project}
                                    location={location}
                                    type={type === 'cybersport' ? 'news' : type}
                                    tag={tag}
                                />
                            );
                        }}
                    />
                </Switch>
                <AuthCheck />
            </Page>
        </BrowserRouter>
    );
}
